import { userConstants } from '../constants/user.constants.js'

export const userActions = {
    login: (user) => ({ type: userConstants.LOGIN, payload: { user } }),
    csrf: (token) => ({ type: userConstants.CSRF, payload: { token } }),
    updatePoint: (point_balance) => ({ type: userConstants.UPDATE_POINT, payload: { point_balance } }),
    updateToken: (token_balance) => ({ type: userConstants.UPDATE_TOKEN, payload: { token_balance } }),
    updateStamp: (stamp) => ({ type: userConstants.LOGIN, payload: { stamp } }),
}
